import {combine, sample} from 'effector';

import {RestError, showRestError} from 'core/errors';
import {initFiltersTable, initSortingsTable} from 'core/hooks/grid2.0';

import {mapRecallAuditFilters} from './mappers';

import {
    data$,
    defaultFilters,
    defaultSortings,
    detailData$,
    DetailGate,
    fetchRecallAuditEventFx,
    fetchRecallAuditLogFx,
    filters$,
    filtersChanged,
    filtersReset,
    Gate,
    pageNumber$,
    pageSize$,
    pageNumberChanged,
    pageSizeChanged,
    sortings$,
    sortingsChanged,
    sortingsReset,
    stateReset,
} from './index';

data$.on(fetchRecallAuditLogFx.doneData, (_, result) => result).reset(Gate.close);
detailData$
    .on(fetchRecallAuditEventFx.doneData, (_, result) => result)
    .reset(fetchRecallAuditEventFx, DetailGate.close);

pageNumber$.reset(filtersChanged, filtersReset, pageSizeChanged, sortingsReset, stateReset);
pageSize$.reset(stateReset);
filters$.reset(Gate.close);

initFiltersTable(filters$, filtersChanged, filtersReset, defaultFilters, stateReset);
initSortingsTable(sortings$, sortingsChanged, sortingsReset, defaultSortings, stateReset);

sample({
    clock: [
        Gate.open,
        filtersChanged,
        filtersReset,
        sortingsChanged,
        sortingsReset,
        pageNumberChanged,
        pageSizeChanged,
    ],
    source: combine({
        filters: filters$,
        pageNumber: pageNumber$,
        pageSize: pageSize$,
    }),
    fn: ({filters, pageNumber, pageSize}) => ({
        ...mapRecallAuditFilters(filters),
        page: pageNumber,
        size: pageSize,
    }),
    target: fetchRecallAuditLogFx,
});

sample({
    clock: DetailGate.open,
    fn: ({eventId}) => eventId,
    target: fetchRecallAuditEventFx,
});

fetchRecallAuditLogFx.fail.watch(({error}) => showRestError(error as RestError));
fetchRecallAuditEventFx.fail.watch(({error}) => showRestError(error as RestError));
